import type { SocialIconKind } from '@ori-ui/components';
import { StaticApplicationsFooterBffSocialMediaLinkDtoType } from '@ori/static-api-client-react';

export const SocialMediaIcons: Record<StaticApplicationsFooterBffSocialMediaLinkDtoType, SocialIconKind> = {
  [StaticApplicationsFooterBffSocialMediaLinkDtoType.Facebook]: 'facebook',
  [StaticApplicationsFooterBffSocialMediaLinkDtoType.VKontakte]: 'vkontakte',
  [StaticApplicationsFooterBffSocialMediaLinkDtoType.Twitter]: 'twitter',
  [StaticApplicationsFooterBffSocialMediaLinkDtoType.YouTube]: 'youtube',
  [StaticApplicationsFooterBffSocialMediaLinkDtoType.Instagram]: 'instagram',
  [StaticApplicationsFooterBffSocialMediaLinkDtoType.Odnoklassniki]: 'odnoklassniki',
  [StaticApplicationsFooterBffSocialMediaLinkDtoType.Weibo]: 'weibo',
  [StaticApplicationsFooterBffSocialMediaLinkDtoType.Pinterest]: 'pinterest',
  [StaticApplicationsFooterBffSocialMediaLinkDtoType.QQ]: 'qq',
  [StaticApplicationsFooterBffSocialMediaLinkDtoType.Youku]: 'youku',
  [StaticApplicationsFooterBffSocialMediaLinkDtoType.Line]: 'youtube',
  [StaticApplicationsFooterBffSocialMediaLinkDtoType.WeChat]: 'wechat',
  [StaticApplicationsFooterBffSocialMediaLinkDtoType.Telegram]: 'telegram',
};
